__turbopack_context__.v({
  "active": "BasicInfoMenu-module__n62nEG__active",
  "companyName": "BasicInfoMenu-module__n62nEG__companyName",
  "dropdown": "BasicInfoMenu-module__n62nEG__dropdown",
  "flexLabel": "BasicInfoMenu-module__n62nEG__flexLabel",
  "flexSwitch": "BasicInfoMenu-module__n62nEG__flexSwitch",
  "menuContainer": "BasicInfoMenu-module__n62nEG__menuContainer",
  "menuTarget": "BasicInfoMenu-module__n62nEG__menuTarget",
  "overlay": "BasicInfoMenu-module__n62nEG__overlay",
  "section": "BasicInfoMenu-module__n62nEG__section",
  "sectionContent": "BasicInfoMenu-module__n62nEG__sectionContent",
  "sectionHeader": "BasicInfoMenu-module__n62nEG__sectionHeader",
  "sidebarContent": "BasicInfoMenu-module__n62nEG__sidebarContent",
  "sidebarWrapper": "BasicInfoMenu-module__n62nEG__sidebarWrapper",
  "switch": "BasicInfoMenu-module__n62nEG__switch",
});
